(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin-data/users/assets/javascripts/services/load-users.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin-data/users/assets/javascripts/services/load-users.js');

'use strict';

const jupiter = svs.core.jupiter;
const loadUsers = callback => {
  jupiter.get('/retailer/1/marketplace/editors', result => {
    callback(null, result.editors);
  }, callback);
};
setGlobal('svs.components.marketplaceRetailAdminData.users.services.loadUsers', loadUsers);

 })(window);